(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsActivity', rmsActivity);

    function rmsActivity($timeout) {
        return {
            restrict: 'E',
            scope: {
                item: '=',
                options: '=?',
                conversation: '=?'
            },
            controller: rmsActivityCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: rmsActivityLink
        };

        function rmsActivityLink(scope, elem) {
            if (scope.vm.item.type == 'schedule') {
                $timeout(function () {
                    elem.find('.activity-schedule-right').css('minHeight', 'calc(' + elem.find('.activity-schedule-left').height() + 'px + 2rem');
                });
            }
        }
    }

    function rmsActivityCtrl($scope, $element, $compile, $templateCache, ActivitiesService, lodash, $timeout, ActionManager) {
        const vm = this;
        this.$onInit = function() {
            ActivitiesService.sync(vm);

            vm.labels = lodash.get(vm, 'options.labels', lodash.get(vm.pageData, 'options.activities.labels', {}));

            if (vm.item.type === 'email') {
                initEmailFunctions();
            }

            const templateUrl = `common/app/components/activities/list-panel/activity-type/${vm.item.type}`;

            const template = $templateCache.get(templateUrl);
            $element.html(template);
            const elementClone = $compile($element.contents())($scope);
            $scope.$on('$destroy', () => {
                elementClone.off();
            });
        }

        function initEmailFunctions() {
            vm.emailModel = getNewEmailReplyModel();

            var activityTypes = lodash.get(vm.pageData,'options.activityTypes',null);
            if (activityTypes !== null) {
                vm.elements = lodash.find(vm.pageData.options.activityTypes, {value: 'email'}).elements;
            }
            vm.showActivityContentInput = false;
            vm.showCC = false;
            vm.showBcc = false;
            vm.errors = {};
            vm.toggleInput = function (type) {
                vm.showActivityContentInput = true;
                lodash.set(vm.emailModel, 'type', type);

                $timeout(function () {
                    const inputContentElem = $element.find('.activity-content-input');
                    angular.element('.grid-detail-content').animate({
                        scrollTop: inputContentElem.offset().top - 250
                    }, 500);
                });
            };
            vm.toggleReply = function(toggle) {
                vm.showEmailContent = toggle;
                if (typeof vm.previewResize === typeof function() {}) {
                    $timeout(function() {
                        vm.previewResize();
                    });
                }
            };
            vm.showEmailContent = false;

            vm.submitEmail = function () {
                vm.submitting = true;
                if (lodash.has(vm.options, 'submitReply')) {
                    vm.options.submitReply(vm.emailModel).then(function(res) {
                        vm.submitting = false;
                        if (!!res && !(lodash.has(res, 'status') && res.status === 422)) {
                            vm.emailModel = getNewEmailReplyModel();
                            ActivitiesService.refreshActivities();
                            vm.showActivityContentInput = false;
                        }
                        if (!!res && (lodash.has(res, 'status') && res.status === 422)) {
                            console.log('show validation error');
                            vm.errors = res.data.rules;
                            console.log(vm.errors);
                        }
                    })
                }
            };

            vm.getErrors = function() {
                return lodash.flatten(lodash.valuesIn(vm.errors)).join(', ')
            };

            vm.hideActivityContentInput = function () {
                vm.showActivityContentInput = false;
            };
            vm.toggleCC = function () {
                vm.showCss = true;
            };
            vm.toggleBCC = function () {
                vm.showBcc = true;
            };

            vm.onAddAttachmentClick = function () {
                const docLibOptions = lodash.get(vm.pageData, 'options.attachmentOptions', {});
                ActionManager('open-document-library',docLibOptions).then(function (result) {
                    result.modal.closed.then(function (res) {
                        if (res !== false) {
                            vm.emailModel.attachments = vm.emailModel.attachments.concat(res);
                        }
                    });
                });
            };

            vm.removeAttachment = function (attachment) {
                const index = lodash.findIndex(vm.emailModel.attachments, {id: attachment.id});
                vm.emailModel.attachments.splice(index, 1);
            };
        }

        function getNewEmailReplyModel() {
            return {
                attachments: [],
                hid_row_ref_id: vm.item.id,
                conversation_id: vm.item.conversation_id
            };
        }
    }
})();